import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import OverrideModal from './OverrideModal'
import { handleApproveChange, handleOverrideChange, fetchOverrideDetails } from '../actions/approvalActions'

export const ActionCell = (props) => {
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch()

  const toggleModal = () => {
    setModal(!modal)
  }

   const sendOverride = (reason, status, ignoreUntil, exclusions, excludedAgreement) => {
      props.handleOverrideChange(props.row, reason, status, ignoreUntil, exclusions, excludedAgreement)
  }

  return (
    <React.Fragment>
      <Button color="success" size="sm" onClick={() => props.handleApproveChange(props.row)}>
        Approve
      </Button>{' '}
      <Button
        color="warning"
        size="sm"
        onClick={() => {
          setModal(!modal)
          dispatch(fetchOverrideDetails(props.row.id))
        }}
      >
        Override
      </Button>
      <OverrideModal row={props.row} modal={modal} toggleModal={toggleModal} sendOverride={sendOverride} />
    </React.Fragment>
  )
}

const mapDispatchToProps = {
  handleOverrideChange,
  handleApproveChange,
}

export default connect(null, mapDispatchToProps)(ActionCell)
